/* Canactivo — scripts de las secciones propias (prefijo mm-). Sin librerías externas. */
(function () {
  var reducir = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function contar(el) {
    if (el.dataset.mmHecho) return;
    el.dataset.mmHecho = '1';
    var fin = parseFloat(el.dataset.mmNum);
    if (isNaN(fin) || reducir) return;
    var decimales = (el.dataset.mmNum.split(/[.,]/)[1] || '').length;
    var duracion = 1400;
    var inicio = null;
    var salida = el.querySelector('[data-mm-valor]');
    if (!salida) return;
    function paso(t) {
      if (!inicio) inicio = t;
      var p = Math.min((t - inicio) / duracion, 1);
      var e = 1 - Math.pow(1 - p, 3);
      salida.textContent = (fin * e).toFixed(decimales).replace('.', ',');
      if (p < 1) requestAnimationFrame(paso);
    }
    salida.textContent = '0';
    requestAnimationFrame(paso);
  }

  function initReveal(raiz) {
    var els = (raiz || document).querySelectorAll('.mm-reveal:not(.mm-visible), [data-mm-num]');
    if (!els.length) return;
    if (reducir || !('IntersectionObserver' in window) || document.documentElement.classList.contains('shopify-design-mode')) {
      els.forEach(function (el) { el.classList.add('mm-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (!en.isIntersecting) return;
          en.target.classList.add('mm-visible');
          if (en.target.hasAttribute('data-mm-num')) contar(en.target);
          observador.unobserve(en.target);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  function initFaq(raiz) {
    (raiz || document).querySelectorAll('[data-mm-faq-unico]').forEach(function (lista) {
      if (lista.dataset.mmListo) return;
      lista.dataset.mmListo = '1';
      lista.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        lista.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }

  // Pasos animados: resalta cada paso por turnos y, en el carrusel del móvil, sigue el deslizamiento
  function initPasosAnim(raiz) {
    (raiz || document).querySelectorAll('[data-mm-pasos-anim]').forEach(function (sec) {
      if (sec.dataset.mmListo) return;
      sec.dataset.mmListo = '1';
      var pasos = [].slice.call(sec.querySelectorAll('[data-mm-paso]'));
      var puntos = [].slice.call(sec.querySelectorAll('[data-mm-ir]'));
      var prog = sec.querySelector('.mm-pa__progreso');
      var grid = sec.querySelector('.mm-pa__grid');
      var n = pasos.length;
      if (n < 2 || !grid) return;
      var activo = 0, visible = false, pausa = false, temporizador = null, espera = null;
      var intervalo = parseInt(sec.dataset.mmIntervalo, 10) || 3000;
      var movil = window.matchMedia('(max-width: 749px)');
      function esCarrusel() { return sec.classList.contains('mm-pa--carrusel') && movil.matches; }
      function marcar(i) {
        activo = i;
        pasos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); });
        puntos.forEach(function (p, k) { p.classList.toggle('is-activo', k === i); p.classList.toggle('is-hecho', k < i); });
        if (prog) prog.style.setProperty('--mm-p', i / (n - 1));
      }
      function irA(i) {
        var p = pasos[i];
        grid.scrollTo({ left: p.offsetLeft - (grid.clientWidth - p.offsetWidth) / 2, behavior: reducir ? 'auto' : 'smooth' });
      }
      function siguiente() { if (!pausa && visible && !esCarrusel()) marcar((activo + 1) % n); }
      marcar(0);
      if (!reducir) temporizador = setInterval(siguiente, intervalo);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(sec);
      } else { visible = true; }
      pasos.forEach(function (p, k) {
        p.addEventListener('mouseenter', function () { if (esCarrusel()) return; pausa = true; marcar(k); });
        p.addEventListener('mouseleave', function () { pausa = false; });
      });
      puntos.forEach(function (b, k) {
        b.addEventListener('click', function () { marcar(k); if (esCarrusel()) irA(k); });
      });
      grid.addEventListener('scroll', function () {
        if (!esCarrusel()) return;
        clearTimeout(espera);
        espera = setTimeout(function () {
          var centro = grid.scrollLeft + grid.clientWidth / 2, mejor = 0, dist = Infinity;
          pasos.forEach(function (p, k) { var d = Math.abs(p.offsetLeft + p.offsetWidth / 2 - centro); if (d < dist) { dist = d; mejor = k; } });
          marcar(mejor);
        }, 80);
      }, { passive: true });
      document.addEventListener('shopify:block:select', function (e) {
        var k = pasos.indexOf(e.target);
        if (k < 0) return;
        pausa = true; marcar(k); if (esCarrusel()) irA(k);
      });
      document.addEventListener('shopify:block:deselect', function () { pausa = false; });
      sec.addEventListener('mm:destruir', function () { clearInterval(temporizador); });
    });
  }

  function init(raiz) { initReveal(raiz); initFaq(raiz); initPasosAnim(raiz); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // En el editor de Shopify, reactivar al añadir o mover secciones
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-mm-pasos-anim]').forEach(function (s) { s.dispatchEvent(new Event('mm:destruir')); });
  });
})();
